import React from 'react';
import HTML5Backend from 'react-dnd-html5-backend';
import { DndProvider } from 'react-dnd';
import DropZoneArea from './drop-zone-area';
import type { Item } from '../../../types/Item';

type Props = {
  className?: string;
  isDisabled?: boolean;
  items: Array<Item>;
  onAddItems: (arg1: FileList) => void;
  onRemoveItem: (arg1: Item) => void;
};

const DropZone = (props: Props) => {
  const {
    isDisabled,
    items,
    onAddItems,
    onRemoveItem,
    className,
    ...ariaAttrs
  } = props;
  return (
    // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2322
    <DndProvider backend={HTML5Backend}>
      <DropZoneArea
        {...ariaAttrs}
        className={className}
        isDisabled={isDisabled}
        items={items}
        onAddItems={onAddItems}
        onRemoveItem={onRemoveItem}
      />
    </DndProvider>
  );
};

export { DropZone };
export default DropZone;
